import React, { useEffect, useRef, useState } from 'react';
import { CUSTOM_FIELD_TYPE_MAPPER } from '../mapper/custom-fields.mapper';
import ConfirmationDialog from '../../../../shared/confirmation-dialog/confirmation-dialog';
import { useCustomFields } from '../hooks/custom-fields.hook';
import getFormattedDate from '../../../../utils/date-format';
import NoDataComponent from '../../../../shared/no-data/no-data';
import Loader from '../../../../shared/loader/loader';
import { Controller, useForm } from 'react-hook-form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CustomFieldsTable = React.forwardRef(({
    customFields,
    addCustomFieldCanvasRef,
    archiveErrorMessage,
    loader,
    deleteCustomField,
    attachField,
    control,
    entityInfo,
    sectionType
}, ref) => {
    const confirmationDialogRef = useRef(null);
    let columns =  [...(attachField ? ["Select"] : []), ...["Label", "Type", "Created At", "Actions"]]
    // columns = (attachField ? [...['Select'],...columns] : [...columns,...['Actions']])

    // useEffect(() => {
    //     if(entityInfo?.entity_id){
    //         getCustomFields(entityInfo?.entity_id);
    //     }
    // }, [entityInfo?.entity_id]);

    // useEffect(() => {
    //     if(customFields?.length > 0){
    //         //processing attached fields
    //         const attachedFields = customFields.flatMap(it => it.fieldAttachmentDetail);
    //     }
    // }, [])



    return (
        <>
            <div className="table-responsive">

                <table className="align-items-center table table-striped table-bordered table-hover">
                    <thead className='text-center prayers-table-header white'>
                        <tr>
                            {
                                columns.map((item, index) => {
                                    return <th key={index}>{item}</th>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody className='prayer-table-body text-center position-relative'>
                        {
                            customFields?.map((item, index) => {
                                return <tr key={'custom_field_' + index}>
                                    {
                                        attachField ? <td>
                                            <Controller
                                                key={item?.id}
                                                control={control}
                                                name="fields"
                                                render={({ field }) => {
                                                    
                                                    const isChecked = field.value.find(it => it.custom_field_id === item?.id && !it?.is_delete);
                                                    return (
                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked?.custom_field_id ? true : false}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    const index = field.value.findIndex(it => it.custom_field_id === item.id);
                                                                    if(index === -1){
                                                                        field.value.push({
                                                                            custom_field_id: item?.id,
                                                                            entity_id: entityInfo?.entity_id,
                                                                            is_delete: false,
                                                                            section_type:sectionType,
                                                                            ...((entityInfo?.entity_type === 'programs' || entityInfo?.entity_type === 'special_initiative') ? {field_label: item?.field_label, field_is_required: item?.field_is_required } : {})
                                                                        })
                                                                    }else{
                                                                        field.value[index].is_delete = false;
                                                                    }

                                                                    // let customField = Object.assign({}, item);
                                                                    // const attachIndex = customField.fieldAttachmentDetail
                                                                    // .findIndex(it => it.entity_id === entityInfo.entity_id);
                                                                    // if(attachIndex !== -1){
                                                                    //     customField.fieldAttachmentDetail[attachIndex].is_delete = false;
                                                                    //     const subIndex = field.value.findIndex(it => it.id === customField?.id);
                                                                    //     if(subIndex === -1){
                                                                    //         field.value.push(customField);
                                                                    //     }else{
                                                                    //         field.value[subIndex] = customField
                                                                    //     }
                                                                        
                                                                    // }else{
                                                                    //     customField.fieldAttachmentDetail.push({
                                                                    //     ...entityInfo, ...{
                                                                    //         custom_field_id: item.id,
                                                                    //         is_delete: false,
                                                                    //     },
                                                                    // });
                                                                    // field.value.push(customField);
                                                                    // }
                                                                    
                                                                    // field.value.push({
                                                                    //     ...entityInfo, ...{
                                                                    //         custom_field_id: item.id,
                                                                    //         is_delete: false,
                                                                    //         id: item?.attachment_id
                                                                    //     },
                                                                    //     ...(subType ? {sub_type: subType} : {sub_type: ''})
                                                                    // });
                                                                } else {
                                                                    const index = field.value.findIndex(it => it.custom_field_id === item.id);
                                                                    if (index >= 0) {
                                                                        field.value[index].is_delete = true;
                                                                        // field.value[index].sub_type = subType ? subType : ''
                                                                        // field.value.splice(index, 1)
                                                                    }
                                                                }
                                                                field.onChange(field.value);
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                            {/* <input onChange={() => {
                                                setSelectedFields((prev) => {
                                                    const clone = structuredClone(prev);
                                                    const index = clone.findIndex(it => it.custom_field_id === item.id);
                                                    if(index >= 0){
                                                        clone.splice(index, 1);
                                                        return clone;
                                                    }else{
                                                        return [...prev, {...entityInfo,...{custom_field_id:item.id}}]
                                                    }
                                                })
                                            }} type='checkbox' /> */}
                                        </td> : ''
                                    }
                                    <td>{item.field_label}</td>
                                    <td>{CUSTOM_FIELD_TYPE_MAPPER[item?.field_type]}</td>
                                    <td>{getFormattedDate(item.created_at)}</td>
                                    <td>
                                        
                                        <OverlayTrigger
                                            placement="auto"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={ <Tooltip>{item?.field_is_delete ? 'Unarchive Filed' : 'Archive Field'}</Tooltip>}
                                        >
                                            <i onClick={() => {
                                                if(item?.field_is_delete){
                                                    deleteCustomField(item, entityInfo?.entity_id);
                                                }else{
                                                    confirmationDialogRef.current.setDialogTitle('Confirm Archive');
                                                confirmationDialogRef.current.setMessage(`Are you sure you want to archive "${item?.field_label}" field?.`);
                                                confirmationDialogRef.current.setButtonLabel("Archive Custom Field");
                                                confirmationDialogRef.current.openDialog(item);
                                                }
                                                
                                            }}
                                                className="cursor-pointer fa-solid fa-file-arrow-down me-2"></i>
                                        </OverlayTrigger>
                                        <i onClick={() => {
                                            addCustomFieldCanvasRef.current.handleShow(item);
                                        }} className="cursor-pointer fa-solid fa-pen-to-square"></i>
                                    </td>
                                    
                                </tr>
                            })
                        }
                    </tbody>

                </table>
                {archiveErrorMessage ? <p className='text-danger'>{archiveErrorMessage}</p> : ''}
                {/* no data message */}
                {

                    !loader && customFields?.length === 0 ?
                        <NoDataComponent message={'No Custom Fields Found!'} /> : ''
                }
                {
                    loader ?
                        <Loader /> : ''
                }
            </div>

            {/* confirmation dialog start */}
            <ConfirmationDialog
                ref={confirmationDialogRef}
                executeAction={(item) => deleteCustomField(item, entityInfo?.entity_id)}
            />
            {/* confirmation dialog end */}
        </>
    );
});

export default CustomFieldsTable;